"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadBakedPng = exports.getImsJson = void 0;
const constants_1 = require("../../constants/constants");
const axiosConfig_1 = require("../axios/axiosConfig");
const getImsJson = (credNo) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let imsJson = yield (0, axiosConfig_1.getAxiosInstance)().get(`${constants_1.ImsRoutes.ims()}/${credNo}`, {
            suppressNetworkError: true,
        });
        return imsJson.data;
    }
    catch (err) {
        return null;
    }
});
exports.getImsJson = getImsJson;
const downloadBakedPng = (credNo, returnOnlyBlobForCertificate) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const axiosInstance = (0, axiosConfig_1.getAxiosInstance)();
        const res = yield axiosInstance.get(`${constants_1.ImsRoutes.imsImage()}/${credNo}`, {
            headers: {
                referrer_full_url: window.location.href,
            },
            responseType: "blob", // Ensure the response is treated as a blob
        });
        const blob = res.data;
        const newBlob = new Blob([blob], { type: "image/png" });
        if (returnOnlyBlobForCertificate)
            return newBlob;
        const blobUrl = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${credNo}.png`);
        link.setAttribute("target", `_blank`);
        document.body.appendChild(link);
        link.click();
        (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
        window.URL.revokeObjectURL(blob);
    }
    catch (err) {
        console.log(err);
        throw err;
    }
});
exports.downloadBakedPng = downloadBakedPng;
